import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import registerBeforeHook from './before'
import routes from './routes'

const router = new Router({
  routes,
  mode: 'history',
  linkActiveClass: 'active'
})

registerBeforeHook(router)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js